module.exports = __webpack_public_path__ + "img/cross.34d823eb.svg";